import { Box, Text, Image } from '@bonanza-social/moonlight';
import { memo } from 'react';

function InvalidResetLink() {
  return (
    <Box
      flex={1}
      justifyContent="center"
      alignItems="center"
      marginBottom="space-2000"
      paddingBottom="safe-area-inset-bottom"
    >
      <Box
        borderRadius="radius-400"
        backgroundColor="primaryBackground"
        maxWidth={600}
        paddingTop="space-1000"
        paddingBottom="space-1000"
        paddingLeft="space-600"
        paddingRight="space-600"
        alignItems="center"
      >
        <Image
          name="common.rejected"
          width={100}
          height={100}
          marginBottom="space-400"
        />
        <Text
          color="darkSurfacePrimary"
          variant="h4"
          textAlign="center"
          marginBottom="space-400"
          locNS="auth"
          locKey="invalidTokenAndId"
        />
        <Text
          color="darkSurfacePrimary"
          variant="body-m"
          textAlign="center"
          locNS="auth"
          locKey="invalidResetLink"
        />
      </Box>
    </Box>
  );
}

export default memo(InvalidResetLink);
